module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-score-column-wrapper"
  }, [_c('div', {
    staticClass: "cat-score-title"
  }, [_vm._v(_vm._s(_vm.categoryName) + " "), _c('tool-tip', {
    attrs: {
      "index": _vm.catIndex
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cat-scores-wrapper"
  }, [_c('div', {
    staticClass: "score-block"
  }, [_c('color-block', {
    attrs: {
      "score": _vm.columnAScore,
      "ishovered": false,
      "name": _vm.categoryName
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "score-block"
  }, [_c('color-block', {
    attrs: {
      "score": _vm.columnBScore,
      "ishovered": false,
      "name": _vm.categoryName
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5023ef4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comparison/CategoryScoreColumn.vue
// module id = 557
// module chunks = 1